// src/pages/Home/components/Navbar3.jsx

import React from "react";

import useNavbar3 from "./Navbar3/hooks/useNavbar3";

import NavbarMenuButton from "./Navbar3/components/NavbarMenuButton";
import NavbarBrand from "./Navbar3/components/NavbarBrand";
import NavbarActions from "./Navbar3/components/NavbarActions";
import NavbarAccountActions from "./Navbar3/components/NavbarAccountActions";
import NavbarMenuPanel from "./Navbar3/components/NavbarMenuPanel";

export default function Navbar3() {
  const navbar = useNavbar3();

  const actionProps = {
    user: navbar.user,

    userRoleId:
      navbar.userRoleId,

    badgeCounts:
      navbar.badgeCounts,

    pendingVotesLoading:
      navbar.pendingVotesLoading,

    loadingConvocations:
      navbar.loadingConvocations,

    canAccessConvocations:
      navbar.canAccessConvocations,

    hasAccessToItem:
      navbar.hasAccessToItem,

    isDarkMode:
      navbar.isDarkMode,

    handleNavigation:
      navbar.handleNavigation,

    toggleTheme:
      navbar.toggleTheme,
  };

  const accountActionProps = {
    user: navbar.user,

    avatarUrl:
      navbar.avatarUrl,

    onProfile: () =>
      navbar.handleNavigation(
        "/profile-utilisateur",
      ),

    onLogout:
      navbar.handleLogout,
  };

  return (
    <>
      <nav
        className="
          fixed inset-x-0 top-0
          z-50
          h-[112px]
          bg-neutral-800
          text-white
          shadow-xl
          md:h-[100px]
        "
      >
        <div
          className="
            flex h-full
            flex-col
            md:flex-row
          "
        >
          {/* Ligne principale */}
          <div
            className="
              flex h-[68px]
              w-full items-center
              md:h-full
            "
          >
            <NavbarMenuButton
              menuOpen={
                navbar.menuOpen
              }
              onToggle={
                navbar.toggleMenu
              }
            />

            <NavbarBrand
              onNavigateHome={() =>
                navbar.handleNavigation(
                  "/",
                )
              }
            />

            {/* Actions principales desktop */}
            <div className="hidden md:block">
              <NavbarActions
                variant="desktop"
                {...actionProps}
              />
            </div>

            {/* Avatar et déconnexion desktop */}
            <div
              className="
                hidden shrink-0
                items-center
                border-l
                border-white/10
                pl-2
                md:flex
              "
            >
              <NavbarAccountActions
                variant="desktop"
                {...accountActionProps}
              />
            </div>

            {/* Avatar et déconnexion mobile */}
            <div
              className="
                flex shrink-0
                items-center
                md:hidden
              "
            >
              <NavbarAccountActions
                variant="mobile"
                {...accountActionProps}
              />
            </div>
          </div>

          {/* Seconde ligne mobile :
              messages, convocations, votes,
              administration et thème */}
          <div
            className="
              h-[44px]
              w-full
              border-t
              border-white/10
              bg-neutral-900/90
              md:hidden
            "
          >
            <NavbarActions
              variant="mobile"
              {...actionProps}
            />
          </div>
        </div>
      </nav>

      <NavbarMenuPanel
        menuOpen={
          navbar.menuOpen
        }
        currentPath={
          navbar.pathname
        }
        hasAccessToItem={
          navbar.hasAccessToItem
        }
        getItemBadgeCount={
          navbar.getItemBadgeCount
        }
        onNavigate={
          navbar.handleNavigation
        }
      />
    </>
  );
}